import { render, staticRenderFns } from "./AnalyticsDashboard.vue?vue&type=template&id=23c86007&scoped=true&"
import script from "./AnalyticsDashboard.vue?vue&type=script&lang=js&"
export * from "./AnalyticsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsDashboard.vue?vue&type=style&index=0&id=23c86007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c86007",
  null
  
)

export default component.exports